import { IIconProps, Icon } from '~/components/Icon';

export const CrossIcon: React.FC<IIconProps> = (props) => (
  <Icon
    data-testid="cross-icon"
    color="secondary.400"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5306 4.53033C12.8235 4.23744 12.8235 3.76256 12.5306 3.46967C12.2377 3.17678 11.7628 3.17678 11.4699 3.46967L8.00024 6.93934L4.53058 3.46968C4.23769 3.17679 3.76282 3.17679 3.46992 3.46968C3.17703 3.76257 3.17703 4.23745 3.46992 4.53034L6.93958 8L3.46991 11.4697C3.17702 11.7626 3.17702 12.2374 3.46991 12.5303C3.76281 12.8232 4.23768 12.8232 4.53057 12.5303L8.00024 9.06066L11.4699 12.5303C11.7628 12.8232 12.2377 12.8232 12.5306 12.5303C12.8235 12.2374 12.8235 11.7626 12.5306 11.4697L9.0609 8L12.5306 4.53033Z"
      fill="currentColor"
    />
  </Icon>
);
